"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideBarToggle = void 0;
var React = __importStar(require("react"));
var react_1 = require("react");
var pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
var Icon_1 = require("../Icon");
var SideBarToggle = function (_a) {
    var _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, _c = _a.onClick, onClick = _c === void 0 ? function () { } : _c;
    var _d = (0, react_1.useState)(isOpen), isShown = _d[0], setIsShown = _d[1];
    var _onClick = function () {
        onClick();
        setIsShown(!isShown);
    };
    return (React.createElement("button", { onClick: _onClick, type: "button", id: "sidebar-toggle", style: {
            cursor: 'pointer',
            height: '46px',
            width: '22px',
            paddingLeft: '7px',
            borderRadius: '0 30% 30% 0',
            transition: 'all 0.5s ease',
        } },
        React.createElement(BackgroundSVG, null),
        React.createElement(Icon_1.Icon, { px: 1, type: isShown ? pro_regular_svg_icons_1.faChevronLeft : pro_regular_svg_icons_1.faChevronRight, size: "lg", color: "white", position: "absolute", zIndex: 2, top: "12px", right: "-3px" })));
};
exports.SideBarToggle = SideBarToggle;
var BackgroundSVG = function () { return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: "22", height: "45" },
    React.createElement("defs", null,
        React.createElement("g", { id: "compShape" },
            React.createElement("path", { d: "M1,1 C21,8 21,8 21,20 C21,19 21,22 21,23 L 1,23 M1,45 C21,37 21,37 21,28 C21,21 21,22 21,23 L 1,23", fill: "silver", stroke: "silver", strokeWidth: "1px" }))),
    React.createElement("use", { xlinkHref: "#compShape", x: "0", y: "0", id: "comp1" }))); };
